import { cloneElement, Fragment } from 'react';
import { createPortal } from 'react-dom';
import { RemoveScroll } from 'react-remove-scroll';
import { useGeneratedId } from '../../../utils/index.js';
import { useIsMobile } from '../../../hooks/useIsMobile.js';
import { useTransitionState } from '../../../hooks/useTransitionState/index.js';
import { MenuContainer, StyledFocusLock } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useFloatingPosition } from '../../../hooks/useFloatingPosition/useFloatingPosition.js';

function Menu(props) {
  var target = props.target,
    children = props.children,
    onClose = props.onClose,
    open = props.open,
    _props$closeOnOutside = props.closeOnOutsideClick,
    closeOnOutsideClick = _props$closeOnOutside === void 0 ? true : _props$closeOnOutside,
    options = props.options,
    className = props.className;
  var state = useTransitionState(open, 200);
  var _useFloatingPosition = useFloatingPosition({
      active: true,
      options: options,
      outsideClickTrigger: function outsideClickTrigger() {
        if (open && closeOnOutsideClick) {
          onClose();
        }
      }
    }),
    refs = _useFloatingPosition.refs,
    wrapperStyle = _useFloatingPosition.wrapperStyle;
  var uniqueId = useGeneratedId('dropdown');
  var isMobile = useIsMobile();
  var clonedTargetWithRef = /*#__PURE__*/cloneElement(target, {
    ref: refs.setReference,
    'aria-haspopup': 'menu',
    'aria-expanded': "" + open
  });
  var shouldRender = state !== 'hidden';
  return /*#__PURE__*/jsxs(Fragment, {
    children: [clonedTargetWithRef, shouldRender && /*#__PURE__*/createPortal( /*#__PURE__*/jsx(RemoveScroll, {
      enabled: isMobile && open,
      children: /*#__PURE__*/jsx(MenuContainer, {
        ref: refs.setFloating,
        role: "menu",
        className: className,
        style: wrapperStyle,
        $state: state,
        children: /*#__PURE__*/jsx(StyledFocusLock, {
          group: uniqueId,
          disabled: !open,
          shards: [refs.reference],
          children: children
        })
      })
    }), document.body)]
  });
}

export { Menu };
